import React from "react";
import {
  AttributeName,
  AttributeValue,
  NameValuePairContainer,
} from "./nameValuePair.styles";

interface INameValuePair {
  name: string;
  value: string | null | undefined;
  emphasizeValue?: boolean;
}

const NameValuePair = ({ name, value, emphasizeValue = false }: INameValuePair) => {
  return (
    <NameValuePairContainer>
      <AttributeName>{name}</AttributeName>
      <AttributeValue $emphasize={emphasizeValue}>{value || "-"}</AttributeValue>
    </NameValuePairContainer>
  );
};

export default NameValuePair;
